/**
 * /* eslint-disable no-unused-vars
 *
 * @format
 */

/** @format */

// import {filter} from 'lodash';
import React, { useState, useEffect } from "react";
// material
import {
  Button,
  Card,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
  CircularProgress,
} from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchToolbar from "../../reusables/table/SearchToolbar";
import SortableTableHeader from "../../reusables/table/SortableTableHeader";
//
// import NumberMoreMenu from "./NumberMoreMenu";
// import { useNavigate } from "react-router-dom";
// import Iconify from "../../components/Iconify";
import {
  applySortFilter,
  getComparator,
} from "../../reusables/table/SortFilterUtils";
import SearchNotFound from "../../components/SearchNotFound";
// import TableMenuDropdown from "../../reusables/table/TableMenuDropdown";
// import TableMenuItem from "../../reusables/table/TableMenuItem";
// import PhoneNumber from "../../dao/PhoneNumber";
// import Waba from "../../dao/Waba";
// import Cost from "../../dao/Cost";
import Approval from "../../dao/Approval";
// import Select from "react-select";
// import swal from "../../reusables/CustomSwal";

// import qs from "qs";
// import { useLocation } from "react-router";
// import { blacklistUser } from "../../static/blacklist";
// import { useSelector } from "react-redux";

import UpdateApprovalMasterDialog from "./UpdateApprovalMasterDialog";
import { timeout } from "../../utils/utilitys";
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "count", label: "No.", alignRight: false },
  { id: "email", label: "Email", alignRight: false },
  { id: "name", label: "Name", alignRight: false },
  { id: "job_title", label: "Job Title", alignRight: false },
  { id: "phone_number", label: "Phone Number", alignRight: false },
  {
    id: "tenant",
    label: "Tenant",
    alignRight: false,
  },
  {
    id: "company_name",
    label: "Company Name",
    alignRight: false,
  },
  {
    id: "status",
    label: "Status",
    alignRight: false,
  },
];

// const TABLE_HEAD_BLACKLIST = [
//   { id: "count", label: "No.", alignRight: false },
//   { id: "phone_num", label: "Phone Broadcast", alignRight: false },
//   { id: "verified_name", label: "Verified Name", alignRight: false },
// ];

// ----------------------------------------------------------------------
export default function ApprovalMasterList(props) {
  // let user = useSelector(({ auth }) => auth.auth);
  // const navigate = useNavigate();
  // const location = useLocation();
  // let email = useSelector(({ auth }) => auth?.auth?.email);
  // const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  // let idParam = queryParams.waba_id;
  // const [addingWaba, setAddingWaba] = useState(false);
  const [updateWaba, setUpdateWaba] = useState(false);

  const [details, setDetails] = useState([]);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("F");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  // eslint-disable-next-line no-unused-vars
  const [cost, setCost] = useState([]);
  const [isDataFetched, setIsDataFetched] = useState(false);

  const [approvalList, setApprovalList] = useState([]);
  // const [selectedWabaId, setSelectedWabaId] = useState(null);
  // const [selectedWabaLabel, setSelectedWabaLabel] = useState(null);
  const getListApproval = async () => {
    try {
      let result = await Approval.getAllApproval();
      await timeout(2000);
      await setIsDataFetched(true);
      await setApprovalList(result);
    } catch (e) {
      // nothing
    }
  };

  useEffect(() => {
    getListApproval();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let count = page * rowsPerPage + 1;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    count = page * rowsPerPage + 1;
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  //   const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage) : 0;
  const filteredData = applySortFilter(
    approvalList,
    getComparator(order, orderBy),
    filterName,
    "email"
  );
  const notFound = filteredData.length === 0;

  // const checkBlackList = !blacklistUser.some((item) => item === email);

  return (
    <Page title="WhatsApp Numbers">
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Approval
          </Typography>
        </Stack>

        {approvalList.length > 0 ? (
          <Card>
            <SearchToolbar
              filterName={filterName}
              onFilterName={handleFilterByName}
            />

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table style={{ backgroundColor: "white", color: "white" }}>
                  <SortableTableHeader
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody>
                    {filteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => {
                        const {
                          // id,
                          // user_id,
                          // waba_id,
                          // approval_by,
                          status,
                          // created_at,
                          // update_at,
                          first_name,
                          last_name,
                          email,
                          phone_number,
                          tenant,
                          job_title,
                          name,
                          // industry,
                        } = row;
                        // const phoneNum = display_phone_number.replace(
                        //   /\D/g,
                        //   ""
                        // );
                        return (
                          <TableRow
                            hover
                            key={row.id}
                            tabIndex={-1}
                            role="checkbox"
                          >
                            <TableCell align="left">{count++}</TableCell>
                            <TableCell align="left">{email}</TableCell>
                            <TableCell align="left">
                              {`${first_name} ${last_name}`}
                            </TableCell>
                            <TableCell align="left">{job_title}</TableCell>

                            <TableCell align="left">{phone_number}</TableCell>
                            <TableCell align="left">{tenant}</TableCell>

                            <TableCell align="left">{name}</TableCell>
                            <TableCell align="left">{status}</TableCell>

                            <TableCell align="right">
                              <Button
                                onClick={() => {
                                  setUpdateWaba(true);
                                  setDetails(row);
                                }}
                              >
                                Edit
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    {/*{emptyRows > 0 && (*/}
                    {/*  <TableRow style={{height: 53 * emptyRows}}>*/}
                    {/*    <TableCell colSpan={6}/>*/}
                    {/*  </TableRow>*/}
                    {/*)}*/}
                  </TableBody>
                  {(notFound || !isDataFetched) && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          {!isDataFetched ? (
                            <CircularProgress />
                          ) : (
                            <SearchNotFound searchQuery={filterName} />
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[10, 20, 50, 100]}
              component="div"
              count={cost.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />

            <UpdateApprovalMasterDialog
              details={details}
              open={updateWaba}
              onClose={(refresh) => {
                setUpdateWaba(false);
                if (refresh) {
                  getListApproval();
                }
              }}
            />
          </Card>
        ) : (
          <CircularProgress />
        )}
      </Container>
    </Page>
  );
}
